import {listMenu} from "data/list";
import {FIELD_TYPE} from "types/enums";
import React from "react";
const {INPUT, SELECT, DATE, COMBO_BOX} = FIELD_TYPE;

const columnsTab: any[] = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },

  {
    title: "Tên tab",
    dataIndex: "tab",
    key: "tab",
    show: true,
  },
  {
    title: "Tên menu",
    dataIndex: "menu",
    key: "menu",
    show: true,
    render: (value, record, index) => {
      return <div>{listMenu?.find(e => e?.value == value)?.label}</div>;
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    show: true,
  },

  // {
  //   title: "",
  //   dataIndex: "",
  //   key: "action",
  //   align: "center",
  //   width: 60,
  //   fixed: "right" as any,
  //   show: true,
  // },
];

export {columnsTab};
